// src/components/AGTUps/services/receiptService.js

import { api } from './config'; // Asegúrate de que este archivo exporte tu instancia configurada de Axios

class ReceiptService {
  /**
   * uploadReceipt
   * Recibe un archivo (imagen o PDF) y lo envía al endpoint /receipts/upload.
   * Devuelve la respuesta del backend con los datos procesados del recibo.
   */
  static async uploadReceipt(file) {
    if (!file) {
      throw new Error('No file provided');
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post('/receipts/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (!response.data?.success) {
        throw new Error('Invalid server response');
      }

      return response.data;
    } catch (error) {
      throw new Error(`Error uploading receipt: ${error.message}`);
    }
  }

  /**
   * getReceipt
   * Obtiene los detalles de un recibo almacenado.
   */
  static async getReceipt(receiptId) {
    if (!receiptId) {
      throw new Error('Receipt ID is required');
    }
    try {
      const response = await api.get(`/receipts/${receiptId}`);
      if (!response.data?.success) {
        throw new Error('Receipt not found');
      }
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching receipt: ${error.message}`);
    }
  }

  /**
   * getRecentUploads
   * Obtiene la lista de recibos subidos con paginación y búsqueda.
   * Se asume que el backend responde con un objeto que contiene:
   * { receipts: [...], totalPages: number }
   */
  static async getRecentUploads(page = 1, limit = 10, search = '') {
    try {
      const response = await api.get('/receipts', {
        params: { page, limit, search }
      });
      if (!response.data?.success) {
        throw new Error('Invalid server response');
      }
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching recent uploads: ${error.message}`);
    }
  }
}

export default ReceiptService;
